"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _lodash = require("lodash");
var _attachments = require("libs/utils/attachments");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var _require = require('src/branded-apps-metadata'),
  FORMS = _require.FORMS;
var languages = require('src/utils/languages');
var groupSidebarItemsById = function groupSidebarItemsById(sections) {
  return _.chain(sections).pluck('items').map(_.values).flatten(1).map(function (item) {
    return [item.id, item];
  }).object().value();
};
var EditAppCtrl = /* @ngInject */function EditAppCtrl($scope, $route, $routeParams, $location, $rootScope, $q, userService, modalService, appBrandingService, accountService, orgService) {
  var brandingId = $scope.brandingId = $routeParams.id;
  if (!brandingId) {
    $rootScope.navigate('/apps');
  }
  var branding = $scope.branding = {};
  $scope.saving = false;

  // Assets ------------------------------------------------------------------------------
  $scope.attachments = [];
  $scope.deleteAsset = function (name) {
    if (!confirm('Are you sure you want to delete this asset?')) {
      return;
    }
    return appBrandingService.deleteAsset($scope.branding, name).finally(function () {
      $scope.attachments = $scope.attachments.filter(function (n) {
        return n !== name;
      });
    });
  };
  function setOwnerName() {
    var _$scope$organisations;
    $scope.ownerName = (_$scope$organisations = $scope.organisations.find(function (org) {
      return org._id === $scope.vm.branding.fp_owner;
    })) === null || _$scope$organisations === void 0 ? void 0 : _$scope$organisations.display_name;
  }

  // App info ----------------------------------------------------------------------------
  $scope.organisations = [];
  orgService.getAllOrgs().then(function (response) {
    $scope.organisations = response.data;
    setOwnerName();
  });

  // Certificates ------------------------------------------------------------------------
  $scope.certificates = null;
  $scope.certificatesStore = '';
  $scope.userIsAppPublisher = userService.matchesRoles({
    globalRole: 'app_publisher'
  }, {
    globalRole: 'superadmin'
  });
  $scope.vm = {
    branding: branding
  };
  accountService.getUser($scope.user.email).then(function (result) {
    $scope.vm.userEvents = _.uniq(result.data.events, '_id');
    $scope.vm.userEventsIds = _.compact(_.pluck(result.data.events, '_id'));
  });

  /* Section switcher */

  var normalizedItem = function normalizedItem(conf) {
    return _.extend({
      visible: function visible() {
        return $scope.canEditApp;
      },
      hasChanged: function hasChanged() {
        return $scope.brandingHasChanged;
      },
      save: function save() {
        return $scope.saveBranding();
      },
      warnings: function warnings() {
        return [];
      }
    }, conf);
  };
  $scope.vm.configSections = {
    dashboard: {
      label: 'Overview',
      icon: 'icon-home',
      items: {
        dashboard: normalizedItem({
          id: 'dashboard',
          label: 'Dashboard',
          visible: function visible() {
            return true;
          },
          hasChanged: function hasChanged() {
            return false;
          }
        }),
        distribution: normalizedItem({
          id: 'distribution',
          label: 'Distribution'
        }),
        assets: normalizedItem({
          id: 'assets',
          label: 'Assets',
          hasChanged: function hasChanged() {
            return false;
          }
        })
      }
    },
    settings: {
      icon: 'icon-cogs',
      label: 'Build',
      items: {
        nameAndIcons: normalizedItem({
          id: 'app-info',
          label: 'Name, icon and splash screen',
          warnings: function warnings() {
            if (!_.size(branding)) {
              return [];
            }
            var warnings = [];
            if (_.isEmpty(branding.springboard_name)) {
              warnings.push('App name is missing');
            }
            if (!appBrandingService.getAssetInfo(branding, 'appIcon')) {
              warnings.push('App icons is missing');
            }
            if (!appBrandingService.getAssetInfo(branding, 'splashScreenPhone')) {
              warnings.push('Splash screen for phones is missing');
            }
            if (!appBrandingService.getAssetInfo(branding, 'splashScreenTablet')) {
              warnings.push('Splash screen for tablets is missing');
            }
            return warnings;
          }
        }),
        theme: normalizedItem({
          id: 'app-theme',
          label: 'Theme',
          warnings: function warnings() {
            if (!_.size(branding)) {
              return [];
            }
            if (!_.size($scope.vm.theme)) {
              return [];
            }
            var warnings = [];
            if (!appBrandingService.getAssetInfo(branding, 'containerTheme') || !appBrandingService.getAssetInfo(branding, 'androidBrandingTheme')) {
              warnings.push('Theme is not configured');
            }
            if (!$scope.vm.theme.version) {
              warnings.push('Invalid theme. Please contact support.');
            }
            return warnings;
          },
          hasChanged: function hasChanged() {
            return $scope.themeHasChanged;
          },
          save: function save() {
            return $scope.saveTheme();
          }
        }),
        bundles: normalizedItem({
          id: 'bundle-ids',
          label: 'Bundles'
        }),
        appLock: normalizedItem({
          id: 'app-lock',
          label: 'Passcode'
        }),
        appDownloading: normalizedItem({
          id: 'downloads',
          label: 'Downloads'
        }),
        health: normalizedItem({
          id: 'healthkit',
          label: 'Health API'
        })
      }
    },
    activation: {
      icon: 'icon-users',
      label: 'Activation',
      items: {
        legal: normalizedItem({
          id: 'legal',
          label: 'Legal'
        }),
        activation: normalizedItem({
          id: 'activation-screen',
          label: 'Screens'
        }),
        invitations: normalizedItem({
          id: 'invitations',
          label: 'Invitations',
          visible: function visible() {
            return userService.hasPermission('app-brandings.app_publisher');
          }
        }),
        sso: normalizedItem({
          id: 'app-sso',
          label: 'Single Sign-On'
        }),
        i18n: normalizedItem({
          id: 'app-i18n',
          label: 'Translations'
        })
      }
    },
    emails: {
      icon: 'icon-email',
      label: 'Emails',
      items: {
        status: normalizedItem({
          id: 'email-status',
          label: 'Email status'
        }),
        invitation: normalizedItem({
          id: 'invitation-email',
          label: 'Invitation'
        }),
        account: normalizedItem({
          id: 'account-email',
          label: 'Create account'
        }),
        accountPasswordReset: normalizedItem({
          id: 'reset-account-password-email',
          label: 'Reset account password'
        }),
        appLockPasswordReset: normalizedItem({
          id: 'reset-app-lock-password-email',
          label: 'Reset Passcode'
        })
      }
    },
    store: {
      icon: 'icon-shop',
      label: 'Store',
      items: {
        info: normalizedItem({
          id: 'store-info',
          label: 'Listing',
          warnings: function warnings() {
            if (!_.size(branding)) {
              return [];
            }
            var warnings = [];
            var storeConfig = branding.store_config || {};
            _.each(FORMS.storeInfo, function (descriptor, field) {
              if (!descriptor.validations) {
                return;
              }
              var validations = descriptor.validations;
              if (validations.required && _.isEmpty(storeConfig[field])) {
                return warnings.push("".concat(descriptor.label, " is missing"));
              }
            });
            if (!appBrandingService.getAssetInfo(branding, 'iosStoreIcon')) {
              warnings.push('App Store icon is missing');
            }
            if (!appBrandingService.getAssetInfo(branding, 'androidStoreIcon')) {
              warnings.push('Google Play icon is missing');
            }
            if (!appBrandingService.getAssetInfo(branding, 'androidFeatureGraphic')) {
              warnings.push('Google Play feature graphic is missing');
            }
            if (_.isEmpty(storeConfig.eid)) {
              warnings.push('Test event is missing');
            }
            if (_.isArray(storeConfig.keywords)) {
              var keywordsString = storeConfig.keywords.join(',');
              if (keywordsString.length > 100) {
                warnings.push('Too many keywords');
              }
              if (keywordsString.indexOf(' ') !== -1) {
                warnings.push('Keywords cannot contain a space');
              }
            }
            return warnings;
          }
        }),
        screenshots: normalizedItem({
          id: 'store-screenshots',
          label: 'Screenshots'
        }),
        // DISABLED until screenshot generator is up and running
        //
        // warnings = []
        // _.each ['ios', 'android'], (platform) =>
        //     screenshotTypes = appBrandingService.getScreenshotTypesForPlatform(platform)
        //     types = _.keys screenshotTypes
        //     _.each types, (type) =>
        //         filenames = appBrandingService.getScreenshotFilenamesOfType(branding, platform, type)
        //         if filenames.length is 0
        //             label = screenshotTypes[type].label
        //             if platform is 'android'
        //                 label = "Android #{label}"
        //             warnings.push label
        //
        // if warnings.length
        //     warnings.unshift 'At least one screenshot is required for:'
        //
        // warnings
        publishing: normalizedItem({
          id: 'store-publishing',
          label: 'Publishing'
        }),
        certificates: normalizedItem({
          id: 'store-certificates',
          label: 'Certificates'
        })
      }
    }
  };
  var getSectionTemplateUrl = function getSectionTemplateUrl(item) {
    return "/static/partials/apps/edit-section-".concat(item, ".html");
  };
  var allSubItems = groupSidebarItemsById($scope.vm.configSections);
  var initialSection = $location.search().section;
  $scope.vm.selectedItem = _.find(allSubItems, {
    id: initialSection
  }) || {
    id: 'dashboard'
  };
  $scope.selectSidebarItem = function (item) {
    if ($scope.vm.selectedItem && typeof $scope.vm.selectedItem.hasChanged === 'function' && $scope.vm.selectedItem.hasChanged()) {
      if (!confirm('You have unsaved changes. These will be lost. Continue?')) {
        return;
      }
      $scope.vm.branding = angular.fromJson(lastSavedBranding);
      setOwnerName();
      $scope.vm.theme = angular.fromJson(lastSavedTheme);
    }
    if (item.id !== 'dashboard' && !$scope.canEditApp) {
      return;
    }
    $scope.vm.selectedItem = item;
    $scope.vm.selectedItemTemplate = getSectionTemplateUrl(item.id);
    return $location.search('section', item.id);
  };

  /* Store info details */
  $scope.storeInfoForm = FORMS.storeInfo;
  $scope.storeUpdateUntilForm = FORMS.updateUntil;

  /* Invitations */
  $scope.invitationsCategoriesForm = FORMS.invitationsCategories;

  /* App Lock */
  $scope.appLockForm = FORMS.appLock;

  /* Screenshots */
  $scope.screenshotSizes = {
    android: {},
    ios: {}
  };
  _.each(['ios', 'android'], function (platform) {
    return _.each(_.keys(appBrandingService.getScreenshotTypesForPlatform(platform)), function (type) {
      $scope.screenshotSizes[platform][type] = appBrandingService.getAssetPreset("screenshot_".concat(platform, "_").concat(type));
    });
  });

  /* $scope API */
  $scope.brandingArtworkUrl = function () {
    if (branding.fp_ext_id) {
      return appBrandingService.getBrandingArtworkUrl(branding.fp_ext_id);
    } else {
      return undefined;
    }
  };
  $scope.save = $scope.saveBranding = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var whiteListedEventKey, branding;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if ($scope.canEditApp) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return");
        case 2:
          whiteListedEventKey = 'invitations_config.only_whitelisted_events';
          branding = $scope.vm.branding;
          if (!((0, _lodash.get)(branding, whiteListedEventKey) && !(0, _lodash.get)(angular.fromJson(lastSavedBranding), whiteListedEventKey))) {
            _context.next = 13;
            break;
          }
          _context.prev = 5;
          _context.next = 8;
          return modalService.openConfirm({
            message: 'Changing "Hide non-linked events" configuration might log out users from the app if the events of this container do not have "Hide from other apps" option checked. Are you sure you want to continue?',
            okLabel: 'Continue'
          });
        case 8:
          _context.next = 13;
          break;
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](5);
          return _context.abrupt("return");
        case 13:
          $scope.saving = true;
          return _context.abrupt("return", appBrandingService.saveBranding(branding).then(function () {
            return $scope.setFlashMessage('Saved.');
          }, function () {
            return alert('An error occured while saving your settings.');
          }).then(getBranding).catch(function (err) {
            return console.error(err);
          }).finally(function () {
            return $scope.saving = false;
          }));
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[5, 10]]);
  }));
  $scope.saveTheme = function () {
    if (!$scope.canEditApp) {
      return;
    }
    $scope.saving = true;
    var fullTheme = appBrandingService.complicateTheme($scope.vm.theme);
    return appBrandingService.saveTheme(branding, fullTheme).then(function () {
      $scope.setFlashMessage('Saved.');
    }, function () {
      return $scope.setFlashMessage('An error occured while saving your settings.', 'danger');
    }).finally(function () {
      $scope.saving = false;
      return getBranding();
    });
  };
  $scope.canPublishApp = function () {
    if ($scope.selectItem && typeof $scope.selectItem.hasChanged === 'function' && $scope.selectItem.hasChanged()) {
      return false;
    }
    return !_.any(allSubItems, function (item) {
      return typeof item.warnings === 'function' ? item.warnings().length : undefined;
    });
  };
  $scope.sendPublishingRequest = function () {
    if (!$scope.canPublishApp()) {
      return alert('Please fill in all missing details before sending a request.');
    }
    return modalService.openModal({
      templateUrl: '/static/partials/apps/modal-create-publishing-request.html',
      scope: {
        request: {
          details: {},
          content: {}
        },
        contentRequest: {},
        requestFields: FORMS.createPublishingRequest,
        contentRequestFields: FORMS.contentRequest
      }
    }).then(function (request) {
      request.details.content = request.content;
      return appBrandingService.createPublishingRequest($scope.vm.branding, request.details).then(function () {
        $scope.setFlashMessage('Request sent.');
        $scope.selectSidebarItem({
          id: 'dashboard'
        });
        return $route.reload();
      }, function () {
        alert('An error occured while sending your request. Please try agian later.');
      });
    });
  };
  $scope.startBuild = function (type) {
    if (!type) {
      type = 'enterprise-build-both';
    }
    return appBrandingService.buildBranding(brandingId, {
      type: type
    }).then(function () {
      return $scope.setFlashMessage('Build launched.');
    }, function () {
      return alert('There was an error while triggering the build.');
    });
  };
  $scope.launchAJob = function () {
    return modalService.openModalWithForm({
      title: 'Start a job',
      fields: FORMS.buildJobs,
      saveLabel: 'Start',
      formCanBeSaved: function formCanBeSaved(model) {
        return model.type;
      }
    }).then(function (options) {
      return appBrandingService.buildBranding(brandingId, options);
    }).then(function () {
      return $scope.setFlashMessage('Build launched.');
    });
  };
  $scope.assignRequestToCurrentUser = function () {
    if (!$scope.vm.currentPublishingRequest) {
      return;
    }
    var currentUserId = userService.getCurrentUser()._id;
    var request = $scope.vm.currentPublishingRequest;
    if (request.assignee) {
      if (request.assignee === currentUserId) {
        return alert('You are already assigned to this request.');
      } else {
        if (!confirm("".concat(request.assignee, " is already assigned to this request. Are you sure you want to take over?"))) {
          return;
        }
      }
    }
    return appBrandingService.assignPublishingRequest(request._id, currentUserId).then(function () {
      $scope.vm.currentPublishingRequest.assignee = currentUserId;
      return $scope.setFlashMessage('You have been assigned.');
    }, function (err) {
      console.error(err);
      return alert('An error occured. Please try again later.');
    });
  };
  $scope.closePublishingRequest = function () {
    if (!$scope.vm.currentPublishingRequest) {
      return;
    }
    return appBrandingService.closePublishingRequest($scope.vm.currentPublishingRequest._id).then(function () {
      $scope.vm.currentPublishingRequest = null;
      return $scope.setFlashMessage('Closed.');
    }, function () {
      return alert('An error occured. Please try again later.');
    });
  };
  $scope.showPublishingRequestUpdateModal = function () {
    if (!$scope.vm.currentPublishingRequest) {
      return;
    }
    return modalService.openModalWithForm({
      title: 'Update publishing request',
      fields: FORMS.statusUpdate,
      saveLabel: 'Update',
      formCanBeSaved: function formCanBeSaved(model) {
        return model.status;
      }
    }).then(function (updates) {
      return appBrandingService.logChange(branding, _.extend(updates, {
        type: 'store-status',
        notify: $scope.vm.currentPublishingRequest.fp_owner
      })).then(function () {
        return $scope.setFlashMessage('Updated.');
      }, function () {
        return alert('An error occured. Please try again later.');
      });
    });
  };
  $scope.showStoreVersionsUpdateModal = function () {
    if (!$scope.userIsAppPublisher) {
      return;
    }
    return modalService.openModalWithForm({
      title: 'Store versions',
      fields: FORMS.storeVersions,
      model: angular.copy($scope.vm.branding.store || {}),
      saveLabel: 'Update'
    }).then(function (updates) {
      $scope.vm.branding.store = $scope.vm.branding.store || {};
      _.extend($scope.vm.branding.store, updates);
      return $scope.save();
    });
  };
  $scope.currentUserHasEvent = function (eid) {
    return ($scope.vm.userEventsIds || []).includes(eid) || !eid;
  };
  $scope.getLanguageName = function (lang) {
    return languages.getName(lang);
  };

  /* Init */
  var lastSavedBranding = null;
  var lastSavedTheme = null;
  $scope.brandingHasChanged = false;
  $scope.$watch(function () {
    return $scope.vm.branding && lastSavedBranding && angular.toJson($scope.vm.branding) !== lastSavedBranding;
  }, function (newValue) {
    $scope.brandingHasChanged = newValue;
  });
  $scope.themeHasChanged = false;
  $scope.$watch(function () {
    return $scope.vm.theme && lastSavedTheme && angular.toJson($scope.vm.theme) !== lastSavedTheme;
  }, function (newValue) {
    $scope.themeHasChanged = newValue;
  });
  $scope.$on('$destroy', function () {
    return $rootScope.currentBranding = null;
  });
  var getBranding = function getBranding() {
    return appBrandingService.getBranding(brandingId).then(function (resp) {
      resp.data.store_config = resp.data.store_config || {};
      appBrandingService.getPublishingAccount(resp.data.publishing_config.account).then(function (_ref2) {
        var data = _ref2.data;
        resp.data.publishing_config.name = data.name;
        angular.copy(resp.data, branding);
        $scope.attachments = (0, _attachments.getAttachmentNames)(branding);
        var updated = angular.copy($scope.vm);
        updated.branding = resp.data;
        $scope.vm = updated;
        setOwnerName();
        // we need this for inline i18n editors :(
        $rootScope.currentBranding = $scope.vm.branding;
        lastSavedBranding = angular.toJson(branding);
        $scope.brandingHasChanged = false;
        var binaryConfigurations = resp.data.binary_configurations;

        // Get the push notification certificates
        if (binaryConfigurations.ios && binaryConfigurations.ios.store && binaryConfigurations.ios.store.bundle_id) {
          $scope.certificatesStore = binaryConfigurations.ios.store.bundle_id;
          if ($scope.userIsAppPublisher) {
            appBrandingService.getPushCertificate(binaryConfigurations.ios.store.bundle_id).then(function (response) {
              $scope.certificates = null;
              if ((0, _attachments.hasAnyAttachments)(response.data)) {
                $scope.certificates = response.data;
                $scope.certificateAttachmentNames = (0, _attachments.getAttachmentNames)(response.data);
              }
            }, function () {
              return console.log('Failed to retrieve push certificates.');
            });
          }
        }
        appBrandingService.getTheme(branding).then(appBrandingService.simplifyTheme).then(function (theme) {
          $scope.vm.theme = theme;
          lastSavedTheme = angular.toJson(theme);
          return $scope.themeHasChanged = false;
        });
      });
    }, function (err) {
      console.error(err);
      return $scope.navigate('/apps');
    });
  };
  var getPublishingRequests = function getPublishingRequests() {
    return appBrandingService.getPublishingRequestsForBranding(brandingId).then(function (resp) {
      var lastRequest = resp.data[0];
      if (!lastRequest) {
        return $scope.canEditApp = true;
      }
      if (lastRequest.status !== 'closed') {
        $scope.vm.currentPublishingRequest = lastRequest;
      }
      return $scope.canEditApp = $scope.userIsAppPublisher ? true : !$scope.vm.currentPublishingRequest;
    }, function (err) {
      console.error(err);
      alert('There was an error retreving publishing requests. Editing has been disabled.');
      return $scope.canEditApp = false;
    });
  };
  var getPublishingAccounts = function getPublishingAccounts() {
    return appBrandingService.getAllPublishingAccounts().then(function (resp) {
      return $scope.vm.publishingAccounts = resp.data;
    });
  };
  $q.all([getBranding(), getPublishingRequests(), getPublishingAccounts()]).then(function () {
    if (initialSection) {
      return $scope.vm.selectedItemTemplate = getSectionTemplateUrl(initialSection);
    }
  });
  var unregister = $scope.$on('brandedAppManager:assetUploadComplete', getBranding);
  return $scope.$on('$destroy', unregister);
};
EditAppCtrl.$inject = ["$scope", "$route", "$routeParams", "$location", "$rootScope", "$q", "userService", "modalService", "appBrandingService", "accountService", "orgService"];
EditAppCtrl.$inject = ["$scope", "$route", "$routeParams", "$location", "$rootScope", "$q", "userService", "modalService", "appBrandingService", "accountService", "orgService"];
angular.module('backstage.controllers.brandedApps').controller('EditAppCtrl', EditAppCtrl);